module.exports = __webpack_public_path__ + "static/media/end-point.d32fe922.svg";